module.exports = __webpack_public_path__ + "static/hansens-go-logo-4a1169b02169bee5b3cee5947ffcf9b8.jpg";